import { useQuery } from '@tanstack/react-query';
import { fetchAgreementByQuote } from '../services/agreements';
import { agreementKeys } from './agreementKeys';

export function useAgreementByQuoteQuery(quoteId: string | undefined) {
    return useQuery({
        queryKey: agreementKeys.byQuote(quoteId ?? ''),
        queryFn: () => fetchAgreementByQuote(quoteId!),
        enabled: !!quoteId,
    });
}
